import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams, useLocation } from "react-router-dom";
import { ChakraProvider, defaultSystem } from "@chakra-ui/react";
import analytics from "./utils/analytics";
import ScrollToTop from "./components/ScrollToTop";
import FixedMegaMenuHeader from "./components/FixedMegaMenuHeader";
import Footer from "./components/Footer";
import SeoManager from "./components/SeoManager";
import EnhancedHomePage from "./components/EnhancedHomePage";
import { CartProvider } from "./components/CartSystem";
import EnhancedGogiWidget from "./components/EnhancedGogiWidget";
import CookieConsentBar from "./components/CookieConsentBar";
import GtmInjector from "./components/GtmInjector";
import EcommercePage from "./components/pages/EcommercePage";
import ProfessionalEcommercePage from "./components/pages/ProfessionalEcommercePage";
import B2BEcommercePage from "./components/pages/B2BEcommercePage";
import EcommerceDesignDetailPage from "./components/pages/EcommerceDesignDetailPage";
import CorporateDesignDetailPage from "./components/pages/CorporateDesignDetailPage";
import MarketingServicesPage from "./components/pages/MarketingServicesPage";
import SeoServicesPage from "./components/pages/SeoServicesPage";
import BrandDesignServicesPage from "./components/pages/BrandDesignServicesPage";
import DigitalDesignsPage from "./components/pages/DigitalDesignsPage";
import PrintMaterialsPage from "./components/pages/PrintMaterialsPage";
import HostingPage from "./components/pages/HostingPage";
import ProjectsPage from "./components/pages/ProjectsPage";
// import MarketplacePage from "./components/pages/MarketplacePage";
import WhatsAppCRM from "./components/WhatsAppCRM";
import UserDashboard from "./components/UserDashboard";
import FAQSection from "./components/FAQSection";
import FAQPageFull from "./components/pages/FAQPageFull";
import BlogPage from "./components/pages/BlogPage";
import SingleBlogPage from "./components/pages/SingleBlogPage";
import EducationPage from "./components/pages/EducationPage";
import EducationDetailPage from "./components/pages/EducationDetailPage";
import ReferencesPage from "./components/pages/ReferencesPage";
import ReferenceDetailPage from "./components/pages/ReferenceDetailPage";
import CorporateWebsitePage from "./components/pages/CorporateWebsitePage";
import ServiceDetailPage from "./components/pages/ServiceDetailPage";
import AllServicesPage from "./components/AllServicesPage";
import DomainPage from "./components/pages/DomainPage";
import VPSServerPage from "./components/pages/VPSServerPage";
import VDSServerPage from "./components/pages/VDSServerPage";
// DedicatedServerPage removed
import CorporateServerPage from "./components/pages/CorporateServerPage";
import SSLCertificatesPage from "./components/pages/SSLCertificatesPage";
import CookiePolicyPage from "./components/pages/CookiePolicyPage";
import Error203 from "./components/pages/Error203";
import Error404 from "./components/pages/Error404";
import Error500 from "./components/pages/Error500";
import KvkkPage from "./components/pages/KvkkPage";
import MarkaTescilPage from "./components/pages/MarkaTescilPage";
import CategoryDetailPage from "./components/pages/CategoryDetailPage";
import SubcategoryDetailPage from "./components/pages/SubcategoryDetailPage";
import ProjectDetailPage from "./components/pages/ProjectDetailPage";
import AdminPanel from "./components/AdminPanel";
import AdminFAQ from "./components/admin/pages/AdminFAQ";
import AdminPopup from "./components/admin/pages/AdminPopup";
import Popup from "./components/Popup";
import CouponWheelPopup from "./components/CouponWheelPopup";
import SearchResultsPage from "./components/pages/SearchResultsPage";
import AboutPage from "./components/pages/AboutPage";
import ContactPage from "./components/pages/ContactPage";
import PaymentSuccessPage from "./components/pages/PaymentSuccessPage";
import ProjectsCatalogPage from "./components/pages/ProjectsCatalogPage";
import ProjectCategoriesPage from "./components/pages/ProjectCategoriesPage";
import SignupPage from "./components/pages/SignupPage";
import LoginPage from "./components/pages/LoginPage";
import HazirWebSitesiTasarimlari from "./components/pages/HazirWebSitesiTasarimlari";
import WebsiteTemplateDetailPage from "./components/pages/WebsiteTemplateDetailPage";
import WebsiteBuilderPage from "./components/pages/WebsiteBuilderPage";
import WordPressHostingPage from "./components/pages/WordPressHostingPage";
import EcommerceHostingPage from "./components/pages/EcommerceHostingPage";
import ResellerHostingPage from "./components/pages/ResellerHostingPage";
import AIDetailPage from "./components/pages/AIDetailPage";
import AdvertisingServicesPage from "./components/pages/AdvertisingServicesPage";
import WebDesignTemplatesPage from "./components/pages/WebDesignTemplatesPage";

const Home = () => <EnhancedHomePage />;

const About = () => (
  <div className="container mx-auto px-6 py-16">
    <div className="max-w-4xl mx-auto">
      <h1 className="text-4xl font-bold text-center mb-8">Hakkımızda</h1>

      <div className="prose prose-lg mx-auto">
        <p className="text-xl text-gray-600 mb-8">
          Website Al, Türkiye'nin en büyük B2B freelance platformudur. 2020
          yılında kurulan platformumuz, işletmelerin dijital dönüşüm
          yolculuğunda güvenilir çözüm ortağı olmayı hedefler.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 my-12">
          <div className="text-center">
            <h3 className="text-3xl font-bold text-purple-600 mb-2">25.000+</h3>
            <p className="text-gray-600">Uzman Freelancer</p>
          </div>
          <div className="text-center">
            <h3 className="text-3xl font-bold text-blue-600 mb-2">150.000+</h3>
            <p className="text-gray-600">Tamamlanan Proje</p>
          </div>
          <div className="text-center">
            <h3 className="text-3xl font-bold text-green-600 mb-2">%99.8</h3>
            <p className="text-gray-600">Müşteri Memnuniyeti</p>
          </div>
        </div>

        <h2 className="text-2xl font-bold mb-4">Misyonumuz</h2>
        <p className="mb-6">
          Türk işletmelerinin dijital dünyada güçlenmesini sağlamak, kaliteli
          freelance hizmetleri erişilebilir kılmak ve teknoloji ile iş dünyasını
          buluşturmak.
        </p>

        <h2 className="text-2xl font-bold mb-4">Vizyonumuz</h2>
        <p className="mb-6">
          2030 yılına kadar Türkiye'nin ve Orta Doğu'nun en büyük dijital
          hizmetler platformu olmak, 1 milyon freelancer ve 500 bin işletmeyi
          bir araya getirmek.
        </p>
      </div>
    </div>
  </div>
);

const FAQPage = () => (
  <div className="container mx-auto px-6 py-16">
    <FAQSection />
  </div>
);

// Redirect component for project detail pages
const ProjectDetailRedirect = () => {
  const { projectId } = useParams();
  return <Navigate to={`/proje/${projectId}`} replace />;
};

// Redirect component for category pages (English to Turkish)
const CategoryRedirect = () => {
  const { categoryId } = useParams();
  return <Navigate to={`/kategori/${categoryId}`} replace />;
};

// Redirect component for subcategory pages (English to Turkish)
const SubcategoryRedirect = () => {
  const { categoryId, subcategoryId } = useParams();
  return <Navigate to={`/kategori/${categoryId}/${subcategoryId}`} replace />;
};

function App() {
  // Ensure page starts at top on initial load
  useEffect(() => {
    // Initialize analytics tracking
    analytics.init();
    
    // Clear any hash immediately
    if (window.location.hash) {
      window.location.hash = '';
    }
    
    // Reset scroll position on app initialization
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    // Additional check after a short delay
    setTimeout(() => {
      if (window.scrollY !== 0) {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }
    }, 100);
  }, []);

  return (
    <ChakraProvider value={defaultSystem}>
      <CartProvider>
        <div className="App">
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <ScrollToTop />
            <SeoManager />
            <GtmInjector />
            <AppContent />
          </BrowserRouter>
        </div>
      </CartProvider>
    </ChakraProvider>
  );
}

function AppContent() {
  const location = useLocation();
  
  // Favicon yönetimi: Sadece /admin/gogiai-conversations sayfasında gogi.svg favicon olsun
  useEffect(() => {
    const isAdminConversationsPage = location.pathname === '/admin/gogiai-conversations';
    
    // Mevcut favicon linklerini bul
    const existingLinks = document.querySelectorAll("link[rel*='icon']");
    
    if (isAdminConversationsPage) {
      // Admin conversations sayfasında gogi.svg favicon kullan
      // Eğer zaten varsa güncelle, yoksa oluştur
      let faviconLink = Array.from(existingLinks).find(link => 
        link.getAttribute('href') === '/gogi.svg' || 
        link.getAttribute('href')?.includes('gogi.svg')
      );
      
      if (!faviconLink) {
        // Mevcut favicon'ları kaldır
        existingLinks.forEach(link => link.remove());
        
        // Yeni gogi.svg favicon oluştur
        faviconLink = document.createElement('link');
        faviconLink.type = 'image/svg+xml';
        faviconLink.rel = 'icon';
        faviconLink.href = '/gogi.svg';
        document.getElementsByTagName('head')[0].appendChild(faviconLink);
      }
    } else {
      // Diğer sayfalarda favicon'u kaldır
      existingLinks.forEach(link => link.remove());
    }
  }, [location.pathname]);

  return (
    <>
      <Routes>
      {/* Admin Routes - Bağımsız Layout */}
      <Route path="/admin/*" element={<AdminPanel />} />

      {/* Ödeme Başarı Sayfası - Özel Route (Header/Footer yok) */}
      <Route path="/odeme/basarili" element={<PaymentSuccessPage />} />
      <Route path="/odeme-basarili" element={<PaymentSuccessPage />} />

      {/* Normal Routes - Header ve Footer ile */}
      <Route
        path="/*"
        element={
          <>
            <FixedMegaMenuHeader />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/arama" element={<SearchResultsPage />} />
                {/** /jobs, /post-job, /submit-proposal removed */}
                <Route path="/kategori/:categoryId" element={<CategoryDetailPage />} />
                <Route path="/kategori/:categoryId/:subcategoryId" element={<SubcategoryDetailPage />} />
                {/* Eski URL'ler için redirect */}
                <Route path="/category/:categoryId" element={<CategoryRedirect />} />
                <Route path="/category/:categoryId/:subcategoryId" element={<SubcategoryRedirect />} />
                <Route path="/sinirsiz-hosting" element={<HostingPage />} />
                <Route path="/bayi-hosting" element={<ResellerHostingPage />} />
                <Route path="/wordpress-hosting" element={<WordPressHostingPage />} />
                <Route path="/e-ticaret-hosting" element={<EcommerceHostingPage />} />
                <Route path="/vps-sunucu" element={<VPSServerPage />} />
                <Route path="/vds-sunucu" element={<VDSServerPage />} />
                {/* /dedicated-server route removed */}
                <Route path="/kurumsal-sunucu" element={<CorporateServerPage />} />
                <Route path="/ssl/ssl-sertifikasi" element={<SSLCertificatesPage />} />
                <Route path="/cerez-politikasi" element={<CookiePolicyPage />} />
                <Route path="/kvkk" element={<KvkkPage />} />
                <Route path="/203" element={<Error203 />} />
                <Route path="/500" element={<Error500 />} />
                <Route path="/marka-tescil-sorgulama" element={<MarkaTescilPage />} />
                {/** /messages removed */}
                
                {/* Turkish Routes - Ana Rotalar */}
                <Route path="/yapay-zeka" element={<AIDetailPage />} />
                <Route path="/proje/:projectId" element={<ProjectDetailPage />} />
                <Route path="/projeler/:projectId" element={<ProjectDetailPage />} />
                <Route path="/projeler" element={<ProjectsPage />} />
                <Route path="/projeler-katalog" element={<ProjectsCatalogPage />} />
                <Route path="/projeler-kategoriler" element={<ProjectCategoriesPage />} />
                <Route path="/hakkimizda" element={<AboutPage />} />
                <Route path="/iletisim" element={<ContactPage />} />
                <Route path="/kayit" element={<SignupPage />} />
                <Route path="/giris" element={<LoginPage />} />
                <Route path="/hesabim" element={<UserDashboard />} />
                <Route path="/profil" element={<UserDashboard />} />
                <Route path="/sikca-sorulan-sorular" element={<FAQPageFull />} />
                
                {/** Kolay Site */}
                <Route path="/web-sitesi-tasarimlari" element={<WebDesignTemplatesPage />} />
                <Route path="/kolay-site" element={<WebsiteBuilderPage />} />
                <Route path="/hazir-web-sitesi-tasarimlari" element={<HazirWebSitesiTasarimlari />} />
                <Route path="/hazir-web-sitesi-tasarimlari/:slug" element={<WebsiteTemplateDetailPage />} />
                <Route path="/kurumsal-web-sitesi" element={<CorporateWebsitePage />} />
                <Route path="/kurumsal-web-sitesi-tasarimlari/:slug" element={<CorporateDesignDetailPage />} />
                
                {/* Blog & Eğitim */}
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:id" element={<SingleBlogPage />} />
                <Route path="/egitim" element={<EducationPage />} />
                <Route path="/referanslar" element={<ReferencesPage />} />
                <Route path="/referanslar/:slug" element={<ReferenceDetailPage />} />
                <Route path="/egitim/:slug" element={<EducationDetailPage />} />
                
                {/* Hizmetler */}
                <Route path="/hizmetler" element={<AllServicesPage />} />
                <Route path="/hizmet/:serviceSlug" element={<ServiceDetailPage />} />
                <Route path="/pazarlama-hizmetleri" element={<MarketingServicesPage />} />
                <Route path="/reklam-yonetimi" element={<AdvertisingServicesPage />} />
                <Route path="/reklam-hizmetleri" element={<AdvertisingServicesPage />} />
                <Route path="/seo-hizmetleri" element={<SeoServicesPage />} />
                <Route path="/marka-tasarim-hizmeti" element={<BrandDesignServicesPage />} />
                <Route path="/dijital-tasarimlar" element={<DigitalDesignsPage />} />
                <Route path="/basili-materyaller" element={<PrintMaterialsPage />} />
                
                {/* E-Ticaret */}
                <Route path="/eticaret" element={<EcommercePage />} />
                <Route path="/profesyonel-eticaret" element={<ProfessionalEcommercePage />} />
                <Route path="/b2b-eticaret" element={<B2BEcommercePage />} />
                <Route path="/eticaret-tasarimlari/:slug" element={<EcommerceDesignDetailPage />} />
                <Route path="/eticaret-hosting" element={<EcommerceHostingPage />} />
                
                {/* Domain */}
                <Route path="/alan-adi" element={<DomainPage />} />
                
                {/* Redirects from old English paths to Turkish slugs */}
                <Route path="/ecommerce" element={<Navigate to="/eticaret" replace />} />
                <Route path="/ecommerce-packages" element={<Navigate to="/eticaret" replace />} />
                <Route path="/ecommerce-designs" element={<Navigate to="/web-sitesi-tasarimlari" replace />} />
                <Route path="/e-ticaret-hosting" element={<Navigate to="/eticaret-hosting" replace />} />
                <Route path="/hosting" element={<Navigate to="/sinirsiz-hosting" replace />} />
                <Route path="/domain" element={<Navigate to="/alan-adi" replace />} />
                <Route path="/projects" element={<Navigate to="/projeler" replace />} />
                <Route path="/project/:projectId" element={<ProjectDetailRedirect />} />
                <Route path="/about" element={<Navigate to="/hakkimizda" replace />} />
                <Route path="/contact" element={<Navigate to="/iletisim" replace />} />
                <Route path="/projects-catalog" element={<Navigate to="/projeler-katalog" replace />} />
                <Route path="/signup" element={<Navigate to="/kayit" replace />} />
                <Route path="/login" element={<Navigate to="/giris" replace />} />
                <Route path="/dashboard" element={<Navigate to="/hesabim" replace />} />
                <Route path="/profile" element={<Navigate to="/profil" replace />} />
                <Route path="/faq" element={<Navigate to="/sikca-sorulan-sorular" replace />} />
                <Route path="/whatsapp-crm" element={<WhatsAppCRM />} />
                {/* 404 Catch-all */}
                <Route path="*" element={<Error404 />} />
              </Routes>
            </main>
            <Footer />

            {/* Floating Widgets */}
            <EnhancedGogiWidget />
            
            {/* Popup Component */}
            <Popup />
            {/* Coupon Wheel Popup */}
            <CouponWheelPopup />
            {/* Cookie Consent */}
            <CookieConsentBar />
          </>
        }
      />
    </Routes>
    </>
  );
}

export default App;
